import React from 'react';
import { PLAN_CONFIG, PLAN_KEYS } from '../constants/plans';
import './PricingTable.css';

export function PricingTable({
  title = 'Choose Your Plan',
  subtitle = '',
  variant = 'home',
  onPlanSelect,
  selectedPlanKey,
}) {
  const handleClick = (planKey, e) => {
    if (variant === 'signup' && onPlanSelect) {
      e.preventDefault();
      onPlanSelect(planKey);
      const form = document.querySelector('.form-contact');
      if (form) form.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <section className="vpn-pricing vpn-pricing--list" id="pricing">
      <div className="vpn-pricing__header">
        <h2 className="vpn-pricing__title">{title}</h2>
        {subtitle && <p className="vpn-pricing__subtitle">{subtitle}</p>}
        <p className="vpn-pricing__note">
          All plans include unlimited bandwidth and no limits — you're only choosing how long you want service.
        </p>
      </div>
      <ul
        className="vpn-pricing-list"
        role={variant === 'signup' ? 'radiogroup' : undefined}
        aria-label={variant === 'signup' ? 'Choose a plan' : undefined}
      >
        {PLAN_KEYS.map((planKey) => {
          const plan = PLAN_CONFIG[planKey];
          const isSelected = variant === 'signup' && selectedPlanKey === planKey;
          const href = variant === 'home' ? `/signup?plan=${planKey}` : '#signup-form';
          const content = (
            <>
              <span className="vpn-pricing-list__radio" aria-hidden="true">
                {isSelected && <span className="vpn-pricing-list__radio-dot" />}
              </span>
              <span className="vpn-pricing-list__label">{plan.label}</span>
              <span className="vpn-pricing-list__desc">{plan.description}</span>
              <span className="vpn-pricing-list__price">
                <span className="vpn-pricing-list__currency">$</span>
                {plan.display}
              </span>
            </>
          );
          return (
            <li key={planKey} className="vpn-pricing-list__item">
              {variant === 'home' ? (
                <a
                  href={href}
                  className={`vpn-pricing-list__option buy_vpn_signup ${isSelected ? 'vpn-pricing-list__option--selected' : ''}`}
                  id={planKey}
                >
                  {content}
                </a>
              ) : (
                <button
                  type="button"
                  className={`vpn-pricing-list__option ${isSelected ? 'vpn-pricing-list__option--selected' : ''}`}
                  id={planKey}
                  onClick={(e) => handleClick(planKey, e)}
                  role="radio"
                  aria-checked={isSelected}
                  aria-label={`${plan.label}, ${plan.description}, $${plan.display}`}
                >
                  {content}
                </button>
              )}
            </li>
          );
        })}
      </ul>
    </section>
  );
}
